import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableTheme } from '../../helpers/tableTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Datetime from 'react-datetime';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { Spinner, InputGroup, Form } from '@themesberg/react-bootstrap';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import CustomErrorView from '../../components/CustomErrorView';
import ColorComponent from '../../components/ColorComponent';
import {
  clearTransactionsData,
  getTransactionByDate,
} from '../../redux/actions/transaction';

const columns = [
  {
    name: 'Transaction Id',
    label: 'Transaction Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Customer Id',
    label: 'Customer Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Customer Name',
    label: 'Customer Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Amount',
    label: 'Amount',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Transaction Type',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  'Collector Name',
  {
    name: 'Transaction Status',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  {
    name: 'Transaction Date',
    label: 'Transaction Date',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
];

function ViewTransactions({ history, match }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format('YYYY-MM-DD')
  );

  const transactionData = useSelector(
    (state) => state.transaction.transactionData
  );

  // useEffect(() => {
  //   if (history.location.pathname === '/transactions/today') {
  //     //display todays transactions here
  //     setIsLoading(true);
  //     dispatch(getTransactionByDate('', true)).then(() => {
  //       setIsLoading(false);
  //     });
  //   } else {
  //     const someDate = match.params?.date;
  //     if (!someDate) {
  //       setShowErrPage(true);
  //     } else {
  //       setBatchDate(someDate);
  //       setIsLoading(true);
  //       dispatch(getTransactionByDate(someDate, false)).then(() => {
  //         setIsLoading(false);
  //       });
  //     }
  //   }

  //   return () => {
  //     dispatch(clearTransactionsData());
  //   };
  // }, []);

  useEffect(() => {
    if (selectedDate !== '') {
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
      setIsLoading(true);
      dispatch(getTransactionByDate(formattedDate, false)).then(() => {
        setIsLoading(false);
      });
    }
    return () => {
      dispatch(clearTransactionsData());
    };
  }, [selectedDate]);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/customers/profile/transactions/${rowData[1]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    download: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    // serverSide: true,
    // viewColumns: false,
    search: true,
    filter: true,
    elevation:0,

    // customToolbar
    customToolbar: () => (
      <Datetime
        timeFormat={false}
        name='selectedDate'
        onChange={setSelectedDate}
        value={selectedDate}
        renderInput={(props, openCalendar) => {
          return (
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faCalendarAlt} />
              </InputGroup.Text>
              <Form.Control
                {...props}
                required
                type='text'
                placeholder='Select Date'
                onFocus={openCalendar}
                value={
                  selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : ''
                }
              />
            </InputGroup>
          );
        }}
      />
    ),
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <>
        <div>
          <MuiThemeProvider theme={tableTheme}>
            {isLoading ? (
              <CustomDashboardLoader />
            ) : (
              <Spinner>
                <MUIDataTable
                  title={'Transactions'}
                  data={transactionData}
                  columns={columns}
                  options={options}
                />
              </Spinner>
            )}
          </MuiThemeProvider>
        </div>
      </>
    );
  }
}

export default ViewTransactions;
